import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Tabs,
    Rate,
    Col,
    Popconfirm,
    message
} from 'antd';
import { Redirect, Link, withRouter } from 'react-router-dom';
import store from "../store/store.js";
import { PlusOutlined } from '@ant-design/icons'
import { PaperClipOutlined, LinkOutlined, SendOutlined, SearchOutlined, ReloadOutlined } from '@ant-design/icons'
import moment from 'moment';
import Edit from './edit.js'
import View from './view.js'
import HtView from '../hetong/view'
import { list } from 'postcss';


const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {},
            newcondition2: {},
            oldcondition: {},
            list: [],
            tableloading: false,
            selectedRowKeys: [],
            count: 0,
            type: '1'
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentWillMount() {
        this.props.GET_REFRESH(this.getdata)
    }

    componentDidMount() {
        // console.log(this.props)
        // let pathname = this.props.location.pathname
        this.props.NAV_CHANGE('/qiye', ['首页', '企业信息'])
        setTimeout(this.getdata(this.state.type, null))

    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.newcondition, { [name]: dateString })
        this.setState({
            newcondition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }
    onSelChange2(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition2, { [name]: value })
        this.setState({
            newcondition2: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(name, dates, dateStrings)
        var data = Object.assign({}, this.state.newcondition, {
            [name + '1']: dateStrings[0], [name + '2']: dateStrings[1]
        })
        if (data) {
            this.setState({
                newcondition: data
            })
        }
    }

    pagechange(page, pagesize) {
        let that = this
        console.log(page, pagesize)
        let data = Object.assign({}, this.state.oldcondition, { current: page, pagesize: pagesize })
        setTimeout(() => {
            this.setState({
                oldcondition: data
            })
            that.getdata(0, null)
        })
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({ selectedRowKeys });
    };

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, { [name]: value })
        this.setState({
            newcondition: data
        })
    }

    getdata = (subtype = 0, e) => {
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, { current: 1, pagesize: old.pagesize })
            that.setState({
                oldcondition: arr
            })
        } else if (subtype == 2) {
            var arr = { ...that.state.newcondition, status: null, honor: null, ...that.state.newcondition2 }
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, { current: 1, pagesize: old.pagesize })
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/Company/index', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg)
                    that.setState({
                        tableloading: false,
                    })
                    return
                }
                that.setState({
                    list: data.datalist,
                    status_react: data.status_react ? data.status_react : [],
                    honor_react: data.honor_react ? data.honor_react : [],
                    yq_react: data.yq_react ? data.yq_react : [],
                    flowtype_react: data.flowtype_react ? data.flowtype_react : [],
                    year_react: data.year_react ? data.year_react : [],
                    tableloading: false,
                    count: Number(data.count)
                })
            })
    }

    delSel() {
        let that = this
        fetch('/Company/allsave', {
            method: "POST", body: JSON.stringify({
                'id': this.state.selectedRowKeys,
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg)
                    return
                }
                this.pagechange(1, this.state.oldcondition.pagesize)
                that.setState({
                    selectedRowKeys: []
                })
            })
    }

    reset() {
        let that = this
        if (that.state.type == 1) {
            that.setState({
                newcondition: {}, oldcondition: {},
            })
            setTimeout(() => {
                that.getdata(that.state.type, null)
            })
        } else if (that.state.type == 2) {
            that.setState({
                list: [],
                count: 0,
                newcondition: {},
                newcondition2: {},
            })
        }
    }

    download(type) {
        // type==1 下载选中部分
        let that = this
        that.setState({
            downloading: true
        })
        var arr = Object.assign({}, this.state.oldcondition, {})
        if (type == 1) {
            arr = {
                id: that.state.selectedRowKeys
            }
        }
        arr.download = 1
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/Company/index', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg);
                    return
                }

                that.setState({
                    downloading: false
                })
                try {
                    var elemIF = document.createElement("iframe");
                    elemIF.src = data.url;
                    elemIF.style.display = "none";
                    document.body.appendChild(elemIF);
                } catch (e) {
                    alert("下载异常！");
                }
            })
    }


    render() {
        const columns = [
            {
                title: '企业名称',
                dataIndex: 'name',
                key: 'name',
                // width: 200,
                fixed: 'left',
                render: (row, record) => {
                    return (<>
                        <View id={record.id} title={row} refresh={this.getdata.bind(this)} />
                        {record.aliasname ? <div style={{ color: 'grey' }}>曾用名：{record.aliasname}</div> : null}
                        {record.qyjc ? <div style={{ color: 'grey' }}>企业简称：{record.qyjc}</div> : null}
                    </>)
                },
            }, {
                title: '统一社会信用代码',
                dataIndex: 'creditCode',
                key: 'creditCode',
                width: 200,
            }, {
                title: '所属园区',
                dataIndex: 'yq_id',
                key: 'yq_id',
                width: 120,
            }, {
                title: '房间号',
                dataIndex: 'room',
                key: 'room',
                width: 120,
            }, {
                title: '合同信息',
                dataIndex: 'contract',
                key: 'contract',
                width: 120,
                render: (row, record) => {
                    return (<>
                        {row && row.length ?
                            (
                                row.map((item) =>
                                    <div key={item.id}><HtView id={item.id} title={item.name} refresh={() => {
                                    }} /></div>
                                )
                            )
                            : null}
                    </>)
                },
            }, {
                title: '欠费信息',
                dataIndex: 'qfxx',
                key: 'qfxx',
                width: 150,
                render: (row, record) => {
                    return (<>
                        <div dangerouslySetInnerHTML={{ __html: row }}></div>
                    </>)
                },
            }, {
                title: '日常联系人',
                dataIndex: 'contacts',
                key: 'contacts',
                width: 120,
            }, {
                title: '日常联系人电话',
                dataIndex: 'phone',
                key: 'phone',
                width: 150,
            }, {
                title: '紧急联系人',
                dataIndex: 'emcontacts',
                key: 'emcontacts',
                width: 120,
            }, {
                title: '紧急联系人电话',
                dataIndex: 'emphone',
                key: 'emphone',
                width: 140,
            }, {
                title: '招商负责人',
                dataIndex: 'zs_fzr',
                key: 'zs_fzr',
                width: 120,
            }, {
                title: '招商部门',
                dataIndex: 'zs_bumen',
                key: 'zs_bumen',
                width: 120,
            }, {
                title: '当前状态',
                dataIndex: 'status',
                key: 'status',
                width: 100,
                fixed: 'right',
                render: (row, record) => {
                    return (<>
                        {row == 1 ? <Tag color={'green'}>{record.status_text}</Tag> : null}
                        {row == 2 ? <Tag color={'red'}>{record.status_text}</Tag> : null}
                    </>)
                },
            }, {
                title: '操作',
                dataIndex: 'cz',
                key: 'cz',
                align: 'center',
                fixed: 'right',
                width: 120,
                render: (row, record) => {
                    return (<>
                        <Space>
                            <View id={record.id} refresh={this.getdata.bind(this)} />
                            {store.getState().data.info.lmqx_bj ? (store.getState().data.info.lmqx_bj.includes('4') ?
                                <Edit refresh={this.getdata.bind(this)} id={record.id} />
                                : null) : null}
                        </Space>
                    </>)
                },
            },]
        const { tableloading, selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys, onChange: this.onSelectChange.bind(this), // hideSelectAll: true,
            preserveSelectedRowKeys: false,
        };
        const hasSelected = selectedRowKeys.length > 0;
        return (<>
            <Tabs onChange={(key) => {
                this.setState({ type: key })
                if (key == 1) {
                    this.getdata(1)
                } else if (key == 2) {
                    this.setState({
                        list: [],
                        count: 0,
                        newcondition: {
                            ...this.state.newcondition,
                            current: 1,
                            pagesize: this.state.oldcondition.pagesize
                        }
                    })
                }
            }}>
                <Tabs.TabPane tab="全部企业" key="1"></Tabs.TabPane>
                <Tabs.TabPane tab="企业变动" key="2"></Tabs.TabPane>
            </Tabs>
            <Row justify="space-between" align="top" style={{ marginBottom: 15 }}>
                <Space wrap>
                    {this.state.type == 2 ? <>
                        <Select placeholder="类型"
                            style={{ width: 120 }}
                            value={this.state.newcondition2.flowtype ? this.state.newcondition2.flowtype : null}
                            onChange={this.onSelChange2.bind(this, 'flowtype')} allowClear>
                            {this.arrsel(this.state.flowtype_react)}
                        </Select>
                        <Select placeholder="年份"
                            style={{ width: 120 }}
                            value={this.state.newcondition2.year ? this.state.newcondition2.year : null}
                            onChange={this.onSelChange2.bind(this, 'year')} allowClear>
                            {this.arrsel(this.state.year_react)}
                        </Select>
                    </> : null}
                    <Input className="input" placeholder="公司名称/房间号"
                        value={this.state.newcondition.keywords ? this.state.newcondition.keywords : null}
                        onChange={this.onChange.bind(this, 'keywords')} autoComplete="off" />
                    <Select placeholder="所属园区"
                        style={{ width: 120 }}
                        value={this.state.newcondition.yq ? this.state.newcondition.yq : null}
                        onChange={this.onSelChange.bind(this, 'yq')} allowClear>
                        {this.arrsel(this.state.yq_react)}
                    </Select>
                    {this.state.type == 1 ? <>
                        <Select placeholder="荣誉称号"
                            style={{ width: 200 }}
                            value={this.state.newcondition.honor ? this.state.newcondition.honor : null}
                            onChange={this.onSelChange.bind(this, 'honor')} allowClear>
                            {this.arrsel(this.state.honor_react)}
                        </Select>
                        <Select placeholder="当前状态"
                            style={{ width: 120 }}
                            value={this.state.newcondition.status ? this.state.newcondition.status : null}
                            onChange={this.onSelChange.bind(this, 'status')} allowClear showSearch
                            optionFilterProp="children">
                            {this.arrsel(this.state.status_react)}
                        </Select>
                    </> : null}
                    <Button type="primary" icon={<SearchOutlined />}
                        onClick={this.getdata.bind(this, this.state.type)}>查询</Button>
                    <Button type="primary" icon={<ReloadOutlined />} className='huise'
                        onClick={this.reset.bind(this)}>重置</Button>
                </Space>
                {store.getState().data.info.lmqx_tj ? (store.getState().data.info.lmqx_tj.includes('4') ?
                    <Edit refresh={this.getdata.bind(this)} />
                    : null) : null}
            </Row>
            <Table
                bordered
                columns={columns}
                dataSource={this.state.list}
                pagination={false}
                loading={tableloading}
                rowSelection={rowSelection}
                className='table'
                scroll={{ x: 2150 }}
                style={{ marginBottom: 20 }}
            />
            <Row justify={'space-between'}>
                <div className='l'>
                    <Space wrap>
                        {hasSelected ? <>
                            {store.getState().data.info.lmqx_sc ? (store.getState().data.info.lmqx_sc.includes('4') ?
                                <Popconfirm
                                    title="确认删除?"
                                    onConfirm={() => this.delSel()}
                                    okText="确认"
                                    cancelText="取消"
                                >
                                    <Button type="primary" danger>删除</Button>
                                </Popconfirm>
                                : null) : null}
                            {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('4') ?
                                <Button type="primary"
                                    onClick={() => this.download(1)}>导出</Button> : null) : null}
                        </> : null}
                        {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('4') ?
                            <Button type="primary" onClick={() => this.download()}>全部导出</Button>
                            : null) : null}
                    </Space>
                </div>
                <Pagination showQuickJumper
                    current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                    pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 10}
                    total={this.state.count} onChange={this.pagechange.bind(this)} showSizeChanger={true}
                    showTotal={total => `共 ${total} 条数据`} />
            </Row>
        </>)
    }
}

export default (props) => <Index {...props} key={props.location.pathname} />
